"use client"

import { ComponentConfig, DropZone } from "@measured/puck"

import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { convertCSSEditMode, generateResponsiveCSS } from "../../lib/helper"

export interface ContainerProps extends CommonStylesProps {
  type: "fluid" | "custom" | "boxed"
  domId?: string
}

export const RenderConfig: ComponentConfig<ContainerProps> = {
  render: ({ type, className, styles, responsiveType, animation, editMode, puck, domId }) => {
    const width = type === "fluid" ? "w-full max-w-full" : ``
    // Separate CSS id (for responsive styles) and DOM id (user-provided)
    const cssId = `box-${Math.random().toString(36).substr(2, 9)}`
    const finalDomId = domId || cssId

    const responsiveCSS = generateResponsiveCSS(cssId, styles || {}, responsiveType)
    const convertedCSSEditMode = styles && convertCSSEditMode(styles)

    const desktopCSSEditMode = convertedCSSEditMode?.desktop
    const mobileCSSEditMode = convertedCSSEditMode?.mobile

    return (
      <>
        {editMode ?? responsiveCSS}
        {/* {responsiveCSS} */}
        <div
          id={finalDomId}
          data-aos={editMode ?? animation?.["data-aos"]}
          data-aos-duration={editMode ?? animation?.["data-aos-duration"]}
          className={twMerge("container mx-auto", width, `${cssId} ${className}`)}
        >
          <DropZone zone="item" style={editMode ? (desktopCSSEditMode as React.CSSProperties) : {}} />
        </div>
      </>
    )
  },
}
